import { useState } from 'react';
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

const CompanySettingsMenu = ({ disabled, onOpenDocReports, onOpenEmails }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleOpenDocReports = () => {
    handleCloseMenu();
    onOpenDocReports();
  };

  const handleOpenEmails = () => {
    handleCloseMenu();
    onOpenEmails();
  };

  return (
    <>
      <IconButton
        onClick={handleOpenMenu}
        disabled={disabled}
        size="small"
        sx={{
          ml: 'auto',
          width: 38,
          height: 38,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          backgroundColor: 'common.white',
          boxShadow: 1,
          '&:hover': {
            backgroundColor: 'grey.50',
          },
        }}
      >
        <SettingsOutlinedIcon fontSize="small" />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
        <MenuItem onClick={handleOpenDocReports}>
          <ListItemIcon>
            <ArticleOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Bizonylat riportok</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleOpenEmails}>
          <ListItemIcon>
            <MailOutlineIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>E-mail címzettek</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default CompanySettingsMenu;
